import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _geDoneWorksCalculationVolumeMetrics(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].GET_DONE_WORKS_CALCULATION_VOLUME_METRICS,
		options
	)
}
function _getDoneWorksCalculationVolumeMetricPreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].GET_DONE_WORKS_CALCULATION_VOLUME_METRIC_PREVIEW,
		options
	)
}
function _getDoneWorksCalculationVolumeMetricPopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].GET_DONE_WORKS_CALCULATION_VOLUME_METRIC_POPUP,
		options
	)
}

function _createDoneWorksCalculationVolumeMetric(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].CREATE_DONE_WORKS_CALCULATION_VOLUME_METRIC,
		options
	)
}

function _getDoneWorksCalculationVolumeMetric(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].GET_DONE_WORKS_CALCULATION_VOLUME_METRIC,
		options
	)
}

function _patchDoneWorksCalculationVolumeMetric(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].PATCH_DONE_WORKS_CALCULATION_VOLUME_METRIC,
		options
	)
}

function _patchDoneWorksCalculationVolumeMetricIntervals(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].PATCH_DONE_WORKS_CALCULATION_VOLUME_METRIC_INTERVALS,
		options
	)
}

function _patchDoneWorksCalculationVolumeMetricBulkUpdate(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].PATCH_DONE_WORKS_CALCULATION_VOLUME_METRIC_BULK_UPDATE,
		options
	)
}

function _putDoneWorksCalculationVolumeMetric(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].PUT_DONE_WORKS_CALCULATION_VOLUME_METRIC,
		options
	)
}

function _deleteDoneWorksCalculationVolumeMetric(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].DELETE_DONE_WORKS_CALCULATION_VOLUME_METRIC,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].GET_DONE_WORKS_CALCULATION_VOLUME_METRICS]: _geDoneWorksCalculationVolumeMetrics,

	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].GET_DONE_WORKS_CALCULATION_VOLUME_METRIC_PREVIEW]: _getDoneWorksCalculationVolumeMetricPreview,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].GET_DONE_WORKS_CALCULATION_VOLUME_METRIC_POPUP]: _getDoneWorksCalculationVolumeMetricPopup,

	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].CREATE_DONE_WORKS_CALCULATION_VOLUME_METRIC]: _createDoneWorksCalculationVolumeMetric,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].GET_DONE_WORKS_CALCULATION_VOLUME_METRIC]: _getDoneWorksCalculationVolumeMetric,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].PATCH_DONE_WORKS_CALCULATION_VOLUME_METRIC]: _patchDoneWorksCalculationVolumeMetric,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].PATCH_DONE_WORKS_CALCULATION_VOLUME_METRIC_INTERVALS]: _patchDoneWorksCalculationVolumeMetricIntervals,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].PATCH_DONE_WORKS_CALCULATION_VOLUME_METRIC_BULK_UPDATE]: _patchDoneWorksCalculationVolumeMetricBulkUpdate,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].PUT_DONE_WORKS_CALCULATION_VOLUME_METRIC]: _putDoneWorksCalculationVolumeMetric,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].DELETE_DONE_WORKS_CALCULATION_VOLUME_METRIC]: _deleteDoneWorksCalculationVolumeMetric,
}